import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import CbkAnswerControls from './CbkAnswerControls';

/**
 * Daftar order yang menunggu jawaban nakes, berbentuk akordeon: satu baris per order,
 * barang dan tombol jawab baru terbuka saat barisnya diketuk. Satu order terbuka sekali waktu.
 * Bila hanya ada satu order, langsung terbuka.
 */
export default function CbkOrderList({ groups, onDone, onWorkflow, testPrefix, rowClass = '' }) {
  const [openId, setOpenId] = useState(null);
  const exists = groups.some((g) => g.order_id === openId);
  const current = exists ? openId : (groups.length === 1 ? groups[0].order_id : null);

  return (
    <div className="space-y-2">
      {groups.map((g) => {
        const isOpen = g.order_id === current;
        const n = g.questions.length;
        return (
          <div key={g.order_id} className={`rounded-lg border border-purple-200 ${rowClass}`}>
            <button
              type="button"
              className="w-full flex items-center gap-2 p-3 text-left"
              onClick={() => setOpenId(isOpen ? '' : g.order_id)}
              aria-expanded={isOpen}
              data-testid={`${testPrefix}-order-${g.order_id}`}
            >
              {isOpen ? <ChevronDown className="w-4 h-4 shrink-0 text-purple-700" /> : <ChevronRight className="w-4 h-4 shrink-0 text-purple-700" />}
              <span className="flex-1 text-sm font-semibold text-gray-900">
                {g.order_id}{g.customer ? ` · ${g.customer}` : ''}
              </span>
              <span className="text-xs text-purple-800 bg-purple-100 rounded-full px-2 py-0.5">{g.questions.every((x) => x.line_type === 'pertanyaan_bebas') ? `${n} pertanyaan` : `${n} barang`}</span>
            </button>
            {isOpen && (
              <div className="px-3 pb-3">
                <button
                  type="button"
                  className="text-xs text-purple-800 underline"
                  onClick={() => onWorkflow(g.order_id)}
                  data-testid={`${testPrefix}-workflow-${g.order_id}`}
                >
                  Lihat workflow order
                </button>
                <div className="mt-2 space-y-3">
                  {g.questions.map((q) => (
                    <div key={q.kasus_id} data-testid={`${testPrefix}-question-${q.kasus_id}`}>
                      <p className="text-sm text-gray-800 whitespace-pre-wrap">{q.text}</p>
                      {q.asked_by && <p className="text-xs text-gray-500">Ditanyakan oleh {q.asked_by}</p>}
                      <CbkAnswerControls q={q} onDone={onDone} testPrefix={testPrefix} />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
